export default window._OI_CONFIG_;